import useLenis from "@/lib/lenis";
import Hero from "@/components/humble/Hero";
import OriginStory from "@/components/humble/OriginStory";
import JoyAndGrief from "@/components/humble/JoyAndGrief";
import PullQuote from "@/components/humble/PullQuote";
import Capabilities from "@/components/humble/Capabilities";
import Waitlist from "@/components/humble/Waitlist";
import Footer from "@/components/humble/Footer";

export default function Landing() {
  useLenis();
  return (
    <main className="relative overflow-hidden bg-cream text-earth">
      <Hero />
      <OriginStory />
      <JoyAndGrief />
      <PullQuote />
      <Capabilities />
      <Waitlist />
      <Footer />
    </main>
  );
}
